import { get } from './client.js';
export const getCommunication = (wsId) => get(`/workspaces/${wsId}/analytics/communication`);
